import facilityImg1 from "../../assets/images/facility-1.png";
import facilityImg2 from "../../assets/images/facility-2.png";
import facilityImg3 from "../../assets/images/facility-3.png";
import facilityImg4 from "../../assets/images/facility-4.png";
import facilityImg5 from "../../assets/images/facility-5.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import styles from "./Facilities.module.css";
import facilitiesBackgroundImg from "../../assets/images/facilities-bg.png";
import SwiperCore, { Autoplay } from "swiper";
SwiperCore.use([Autoplay]);

const facilityData = [
  {
    id: 1,
    img: facilityImg1,
    label: "Football",
  },
  {
    id: 2,
    img: facilityImg2,
    label: "Football",
  },
  {
    id: 3,
    img: facilityImg3,
    label: "Football",
  },
  {
    id: 4,
    img: facilityImg4,
    label: "Football",
  },
  {
    id: 5,
    img: facilityImg5,
    label: "Football",
  },
];

const Facilities = () => {
  return (
    <section
      style={{ backgroundImage: `url(${facilitiesBackgroundImg})` }}
      className={styles.section}
    >
      <h2 className={styles.heading}>Facilities We Offer</h2>
      <Swiper
        slidesPerView={2}
        spaceBetween={0}
        breakpoints={{
          450: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          900: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        }}
        className="mySwiper"
        loop={true}
        speed={3000}
        autoplay={{
          delay: 1,
          disableOnInteraction: false,
        }}
      >
        {facilityData.map((item) => {
          return (
            <SwiperSlide key={item.id}>
              <figure className={styles.card}>
                <img className={styles.cardImg} src={item.img} alt="icon" />
                <figcaption className={styles.label}>{item.label}</figcaption>
              </figure>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Facilities;
